export enum ResearchTeamMemberRoleEnum {
    Lead = 'Lead',
    Statistician = 'Statistician',
    AdditionalResearcher = 'AdditionalResearcher',
}
